'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiThLargeOutline = function TiThLargeOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm15 3.3h-8.3c-1.9 0-3.4 1.5-3.4 3.4v8.3c0 1.8 1.5 3.3 3.4 3.3h8.3c1.8 0 3.3-1.5 3.3-3.3v-8.3c0-1.9-1.5-3.4-3.3-3.4z m0 11.7h-8.3v-8.3h8.3v8.3z m18.3-11.7h-8.3c-1.8 0-3.3 1.5-3.3 3.4v8.3c0 1.8 1.5 3.3 3.3 3.3h8.3c1.9 0 3.4-1.5 3.4-3.3v-8.3c0-1.9-1.5-3.4-3.4-3.4z m0 11.7h-8.3v-8.3h8.3v8.3z m-18.3 6.7h-8.3c-1.9 0-3.4 1.5-3.4 3.3v8.3c0 1.9 1.5 3.4 3.4 3.4h8.3c1.8 0 3.3-1.5 3.3-3.4v-8.3c0-1.8-1.5-3.3-3.3-3.3z m0 11.6h-8.3v-8.3h8.3v8.3z m18.3-11.6h-8.3c-1.8 0-3.3 1.5-3.3 3.3v8.3c0 1.9 1.5 3.4 3.3 3.4h8.3c1.9 0 3.4-1.5 3.4-3.4v-8.3c0-1.8-1.5-3.3-3.4-3.3z m0 11.6h-8.3v-8.3h8.3v8.3z' })
        )
    );
};

exports.default = TiThLargeOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/th-large-outline.js
// module id = 2216
// module chunks = 0